import { useContext } from 'react';
import TextsContext from './TextsContext';

export default function useTextsLoading() {
  return useContext(TextsContext).texts === undefined;
}
